import { getCookie, useGetContext } from '../lendingApi/lendingApiQueries';
import { TGetContext } from '../types';

export const truthyValues = ['True', 'true', true];

type TSplitTextFromContext = TGetContext['data']['user_split_tests'][number];

export const getSplitTestFromContext = (
  splitTestToFind: string,
  context: TGetContext['data'],
) => {
  const overrideCookie = getCookie(`splittest_${splitTestToFind}`);

  if (overrideCookie !== null)
    return {
      [splitTestToFind]: truthyValues.includes(overrideCookie),
    };

  return context?.user_split_tests?.find(
    (splitTest) =>
      splitTest && Object.keys(splitTest).includes(splitTestToFind),
  );
};

export function useSplitTest() {
  const { context } = useGetContext();

  const hasSplitTestEnabledWithContext = (
    splitTestToFind: keyof TSplitTextFromContext,
    splitTestValue?: TSplitTextFromContext[keyof TSplitTextFromContext],
  ) => {
    const splitTest = getSplitTestFromContext(splitTestToFind, context);

    if (!splitTest) return false;

    if (!splitTestValue) {
      return Boolean(splitTest[splitTestToFind]);
    }

    if (
      typeof splitTestValue === 'string' &&
      splitTest[splitTestToFind] === splitTestValue
    ) {
      return true;
    } else return false;
  };

  const isDEAnyBSRequired =
    hasSplitTestEnabledWithContext(
      'de_auto_bs_required_test_2024',
      'ANY_BS_REQUIRED',
    ) ||
    hasSplitTestEnabledWithContext(
      'de_manual_lending_open_banking_required_test_2024_q4',
      'ANY_BS_REQUIRED',
    ) ||
    hasSplitTestEnabledWithContext(
      'de_auto_bs_required_test_2024',
      'NOT_REQUIRED_ANY_IF_DECLINED',
    );

  const isDeOBRequired =
    hasSplitTestEnabledWithContext(
      'de_auto_bs_required_test_2024',
      'OB_REQUIRED',
    ) ||
    hasSplitTestEnabledWithContext(
      'de_manual_lending_open_banking_required_test_2024_q4',
      'OB_REQUIRED',
    ) ||
    hasSplitTestEnabledWithContext(
      'de_auto_bs_required_test_2024',
      'NOT_REQUIRED_OB_IF_DECLINED',
    );

  return {
    splitTests: context?.user_split_tests,
    hasTrueLayerConsentFlowEnabled: hasSplitTestEnabledWithContext(
      'new_truelayer_consent_flow',
    ),
    hasMiddleNameTestEnabled: hasSplitTestEnabledWithContext(
      'partner_middle_name_test_2025',
    ),
    hasInterestOnlyEnabled: hasSplitTestEnabledWithContext(
      'signup_interest_only_test_2023',
    ),
    hasBusinessDetailsReductionEnabled: hasSplitTestEnabledWithContext(
      'business_details_reduction',
    ),
    hasDeBSRequiredEnabled: isDeOBRequired,
    hasDeAnyBSRequiredEnabled: isDEAnyBSRequired,
  };
}
